import { INTEGRATION_PROVIDERS } from '@vy/types';
import { useActivatedIntegration } from '../../../use-activated-integration';

export function useAnrokEnabled() {
  return useActivatedIntegration(INTEGRATION_PROVIDERS.anrok, {
    suspense: true,
  });
}
